import { PasswordReset } from '@/features/auth';

const PasswordResetPage = () => {
  return <PasswordReset />;
};

export default PasswordResetPage;
